module.exports = __webpack_public_path__ + "img/1074410525.aee92d67.jpg";